import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TimesheetsService {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  }

  GetTimeSheetBillableDetailsList(fromdate, todate) {
    return this.http.get<any>('Timesheet/GetTimeSheetBillableDetailsList?fromdate=' + fromdate + '&todate=' + todate);
  }

  GetTimeSheetBillableDetailsListSelectedUser(fromdate, todate, userId) {
    return this.http.get<any>('Timesheet/GetTimeSheetBillableDetailsListSelectedUser?fromdate=' + fromdate + '&todate=' + todate + '&userId=' + userId);
  }

  GetTimeSheetDailyDetailsList(fromdate, todate) {
    return this.http.get<any>('Timesheet/GetTimeSheetDailyDetailsList?fromdate=' + fromdate + '&todate=' + todate);
  }

  GetTimeSheetDetailsListbydate(date) {
    return this.http.get<any>('Timesheet/GetTimeSheetDetailsListbydate?date=' + date);
  }

  GetTeamsForTimesheet() {
    return this.http.get<any>('Teams/TeamsForPlanningAndTimeSheetCombo');
  }

  GetTeamsTimesheetPrivileges() {
    return this.http.get<any>('Teams/TeamsWithTimeSheetPrivileges');
  }

  GetTeams() {
    return this.http.get<any>('Teams/Teams');
  }

  DeleteMultipleTimeLog(date) {
    return this.http.post<any>('Timesheet/DeleteMultipleTimeLog', date, { headers: this.headers });
  }

  DeleteTimeLog(timeLogId, isDeleted) {
    return this.http.get<any>('Timesheet/DeleteTimeLog?timeLogId=' + timeLogId + '&isDeleted=' + isDeleted);
  }

  DeleteweeklyTimeLog(request) {
    return this.http.post<any>('Timesheet/DeleteweeklyTimeLog', request);
  }

  addAuditorsDetail(auditorsDetailsData) {
    return this.http.post<any>('Entity/AddAuditorDetail', auditorsDetailsData)
  }

  //Get WeeklyDetail  based on User ID 
  GetWeeklyTimesheetByUser(fromdate, todate) {
    return this.http.get<any>('Timesheet/GetWeeklyTimesheetByUser?fromdate=' + fromdate + '&todate=' + todate);
  }

  GetWeeklyTimesheetByUserSelection(fromdate, todate, userid) {
    return this.http.get<any>('Timesheet/GetWeeklyTimesheetByUserSelection?fromdate=' + fromdate + '&todate=' + todate + '&userid=' + userid);
  }

  GetDailyTimesheetByUserSelection(selectedDate, userid) {
    return this.http.get<any>('Timesheet/GetDailyTimesheetByUserSelection?SelectedDate=' + selectedDate + '&userid=' + userid);
  }

  GetWeeklyTimesheetHolidayDetail(fromdate, todate, Isflag = false) {
    return this.http.get<any>('Timesheet/GetWeeklyHolidayTimesheet?fromdate=' + fromdate + '&todate=' + todate + '&Isflag=' + Isflag);
  }

  GetMonthlyTimesheetByUserSelection(fromdate, userid) {
    return this.http.get<any>('Timesheet/GetMonthlyCalenderView?fromdate=' + fromdate + '&userid=' + userid);
  }

  GetJobListForTimesheetByUserId() {
    return this.http.get<any>('Timesheet/GetJobListForTimesheetByUserId')
  }

  GetMileStoneByJobId(jobid) {
    return this.http.get<any>('Job/GetJobStatusforjobId?jobId=' + jobid);
  }

  GetManagerAssignStaff() {
    return this.http.get<any>('Timesheet/GetManagerAssignStaff');
  }

  GetLogCommentDetails(Id) {
    return this.http.get<any>('Job/GetLogCommentDetails?Id=' + Id);
  }
  
  GetUserTimesheetByUserId() {
    return this.http.get<any>('Timesheet/GetUserTimesheetByUserId');
  }

  GetUserPermission(roleId) {
    return this.http.get<any>('Account/GetPermissions/' + roleId);
  }

  discardDraftChanges(data) {
    return this.http.post<any>('Timesheet/DeleteTimeLogForDraftStatus', data);
  }

  GetReporteeTimesheetdate(Userid, isPendingLogView: boolean, startDate: string, endDate: string, searchText: string) {
    return this.http.get<any>('Timesheet/GetReporteeTimeSheetDate?UserId=' + Userid + '&isPendingTimesheet=' + isPendingLogView + '&startDate=' + startDate + '&endDate=' + endDate + '&searchText=' + searchText);
  }

  deleteRowData(id) {
    const body = { 'LogTimeId': id };
    return this.http.post<any>('Timesheet/DeleteRowTimeLogData', body);
  }

  UpdateTimesheetStatus(lstLogId: string, statusId: number, comment: string, AnotherUserId: string, userId: string, timeLogCommentType: number) {
    let request = {
      jsnLogTimeIdStr: lstLogId,
      StatusId: statusId,
      Comment: comment,
      AnotherUserId: AnotherUserId,
      userId: userId,
      timeLogCommentType
    }
    return this.http.post<any>('Timesheet/UpdateTimeSheetDataStatus', request);
  }

  GetTimeSheetDailyBillableDetailsListSelectedUser(fromdate, todate, userId, Area) {
    return this.http.get<any>('Timesheet/GetTimeSheetBillableDetailsListSelectedUser?fromdate=' + fromdate + '&todate=' + todate + '&userId=' + userId + '&Area=' + Area);
  }

  GetReporteeTimesheet(Userid: string, timesheetType: boolean, searchText: string): Observable<any> {
    const url = `Timesheet/GetReporteeTimesheet?UserId=${Userid}&TimesheetType=${timesheetType}&searchText=${searchText}`;
    return this.http.get<any>(url);
  }

  GetAllTimesheet(Userid: string, timesheetType: boolean, startDate: string, endDate: string): Observable<any> {
    const url = `Timesheet/GetAllTimesheet?UserId=${Userid}&TimesheetType=${timesheetType}&startDate=${startDate}&endDate=${endDate}`;
    return this.http.get<any>(url);
  }

  GetMonthlyTimesheetCalenderView(Userid: string, timesheetType: boolean, FromDate): Observable<any> {
    const url = `Timesheet/GetMonthlyTimesheetCalenderView?UserId=${Userid}&TimesheetType=${timesheetType}&FromDate=${FromDate}`;
    return this.http.get<any>(url);
  }

  getSuggestion(Userid, startDate: string) {
    return this.http.get<any>('Timesheet/GetTimesheetsuggestion?UserId=' + Userid + '&startDate=' + startDate);
  }

  getTimesheetLeaveAndOtherList() {
    return this.http.get<any>('Timesheet/GetItemListForTimesheetByUserId', { headers: this.headers });
  }

  getClientJobsList(clientID, jobCategory = 7) {
    return this.http.get<any>('Job/GetJobsList?clientId=' + Number(clientID) + '&jobCategory=' + jobCategory + '&IsArchive=false', { headers: this.headers });
  }

  getTimesheetTaskByID(ContextId) {
    return this.http.get('Timesheet/GetTaskByContextId?ContextId=' + ContextId + '&ContextType=Job');
  }

  GetLeavedetails() {
    return this.http.get<any>('Timesheet/GetLeavedetails', { headers: this.headers })
  }

  GetUserPreferences() {
    return this.http.get<any>('UserManagement/GetUserPreferences', { headers: this.headers })
  }

  addEditUserPreferences(data) {
    return this.http.post<any>('UserManagement/AddEditUserPreferences', data)
  }

  GetMasterTimeSheetDetailsByUserId(userId: string): Observable<any> {
    const url = `Timesheet/GetMasterTimeSheetDetailsByUserId?userId=${userId}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  GetPendingLogTimeCount(userId: string, timesheetType: boolean): Observable<any> {
    const url = `Timesheet/GetPendingLogTimeCount?userId=${userId}&timesheetType=${timesheetType}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  GetAlllogTimeCount(userId: string, timesheetType: boolean, startDate: string, endDate: string, isTeamMemberViewAllTimesheet: boolean): Observable<any> {
    const url = `Timesheet/GetAlllogTimeCount?userId=${userId}&timesheetType=${timesheetType}&startDate=${startDate}&endDate=${endDate}&isTeamMemberViewAllTimesheet=${isTeamMemberViewAllTimesheet}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  disbursementTransfer(selctedTransferJob, selctedTransferClient, disbursementIds, comments: string = '') {
    return this.http.get<any>('Billing/AddDisbursementTransferAsync?clientId=' + Number(selctedTransferClient) + '&jobId=' + Number(selctedTransferJob) + '&disbursement=' + disbursementIds + '&comments=' + encodeURIComponent(comments), { headers: this.headers });
  }

  GetTaskByContextId(ContextId, ContextType) {
    return this.http.get('Timesheet/GetTaskByContextId?ContextId=' + ContextId + '&ContextType=' + ContextType)
  }

  getAllCommentForLogId(LogId: number, logTimeCommentType: string): Observable<any> {
    const url = `LogTime/GetAllCommentForLogId?LogId=${LogId}&logTimeCommentTypes=${logTimeCommentType}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  getWIPLockInfo(WIPLockRequest) {
    return this.http.post<any>(`Billing/GetWIPLockDetails`, WIPLockRequest, { headers: this.headers });
  }
}
